import {Bounce} from "gsap";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export interface IShakeConfig {
    x: number;
    y: number;
    obj: PIXI.DisplayObject | StageLayer;
    duration: number;
    Intensity?: number;
    hertz: number;
    ease?: any;
    reverseEase?: boolean;
    positionCb?: () => PIXI.Point;
    updateOnComplete?: boolean;
}

export class AnimationEffects {

    public static Yoyo(config: IShakeConfig): gsap.core.Timeline {
        let startPosY: number = config.obj.y;
        let startPosX: number = config.obj.x;

        let t: boolean = true;

        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => {
                if (config.positionCb) {
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                } else if (config.updateOnComplete) {
                    config.obj.y = startPosY;
                    config.obj.x = startPosX;
                }
            },
            onUpdate: () => {
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = config.ease ? config.ease(nt) as number : nt;
                if (config.reverseEase) et = 1 - et;
                if (t) {
                    t = false;
                    return;
                }
                if (config.positionCb) {
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }

                config.obj.x = startPosX + config.x * et;
                config.obj.y = startPosY + config.y * et;
            }
        });
        tl.to(this, {duration: config.duration})
        return tl;
    }

    public static Shake(config: IShakeConfig): gsap.core.Timeline {
        let startPosY: number = config.obj.y;
        let startPosX: number = config.obj.x;

        let t: boolean = true;
        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onStart: () => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete: () => {
                if (config.positionCb) {
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                } else if (config.updateOnComplete) {
                    config.obj.y = startPosY;
                    config.obj.x = startPosX;
                }
            },
            onUpdate: () => {
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = config.ease ? config.ease(nt) as number : nt;
                if (t) {
                    t = false;
                    return;
                }
                if (config.positionCb) {
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }

                if (config.reverseEase)
                    et = 1 - et;
                if (config.Intensity) {
                    if (config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt * config.hertz) * (config.Intensity * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * (config.Intensity * et)) * config.x;
                } else {
                    if (config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt * config.hertz) * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * et) * config.x;
                }
            }
        });
        tl.to(this, {duration: config.duration})
        return tl;
    }

    public static Bounce(target: PIXI.DisplayObject, sizeExp: number = 1.2, durr: number = 0.25): gsap.core.Tween {
        const startScale: PIXI.Point = MathHelper.pointMul(target.scale, sizeExp);
        const initScale: PIXI.Point = MathHelper.pointMul(target.scale, 1);
        return gsap.fromTo(target.scale, {x: startScale.x, y: startScale.y}, {
            x: initScale.x,
            y: initScale.y,
            duration: durr,
            ease: Bounce.easeOut
        })
    }
}